import React from 'react';
import AccountTransactionFP from '../FullPagesComponents/Services/AccountTransactionFP';
import SimulatorsViewerArrangement from '../FullPagesComponents/SimulatorsViewerArrangement';
import {
  Account_name,
  Account_number,
  Account_number_number,
  Action_success,
  Amazon,
  Amount,
  Cash_back,
  CBS_ID,
  CBS_ID_number,
  Confirm_action,
  Date_25_8_2021,
  Date_28_8_2021,
  Default_view,
  Default_view_indication, getSubCategory,
  getSubCategoryId,
  Multiple_accounts_categories,
  Pending_9_32,
  Price_12_50,
  two_hundred_dollars,
  Price_minus_34_87,
  Price_minus_750,
  Recipient_str,
  Rent_str,
  Saturday_28_Aug,
  SMS_sent,
  Time_11_00,
  Time_17_00,
  Time_9_32,
  Transaction_details_one_action,
  Transaction_details_two_action,
  Trx_date,
  Trx_date_number,
  Trx_ID,
  Trx_ID_number,
  userNameSD,
  Yesterday,
} from '../../../utils/DictionaryManagementUtils';
import ActionSuccessFP from '../FullPagesComponents/Services/Success/ActionSuccessFP';
import ConfirmActionFP from '../FullPagesComponents/Services/Confirmation/ConfirmActionFP';
import TransactionDetailsFP from '../FullPagesComponents/Services/TransactionDetailsFP';

const AccountInfoInOutDF = ({
  globJSON,
  selectedScreen,
  language,
  simPlatform,
  slideshowRefs = null,
}) => {
  const myScreen = globJSON.screens[selectedScreen];
  const subCategoryId = getSubCategoryId(myScreen);
  const subCategory = getSubCategory(subCategoryId);
  const { transactions } = globJSON.configurations.services[subCategoryId];
  const { enable_more_details_per_transaction } = transactions;
  const transactionsListDate = [
    {
      txtAmount: Price_minus_34_87,
      txtPrimary: Amazon,
      txtSecondary: Date_28_8_2021,
    },
    {
      txtAmount: two_hundred_dollars,
      txtPrimary: userNameSD,
      txtSecondary: Date_28_8_2021,
      isPositive: true,
    },
    {
      txtAmount: Price_12_50,
      txtPrimary: Cash_back,
      txtSecondary: Date_25_8_2021,
      isPositive: true,
    },
    {
      txtAmount: Price_minus_750,
      txtPrimary: Rent_str,
      txtSecondary: Date_28_8_2021,
    },
  ];
  const transactionsListTime = [
    {
      txtPrimary: Yesterday,
      isDate: true,
    },
    {
      txtAmount: Price_minus_34_87,
      txtPrimary: Amazon,
      txtSecondary: Time_11_00,
    },
    {
      txtAmount: two_hundred_dollars,
      txtPrimary: userNameSD,
      txtSecondary: enable_more_details_per_transaction ? Pending_9_32 : Time_9_32,
      isPositive: !enable_more_details_per_transaction,
      isPending: enable_more_details_per_transaction,
    },
    {
      txtPrimary: Saturday_28_Aug,
      isDate: true,
    },
    {
      txtAmount: Price_12_50,
      txtPrimary: Cash_back,
      txtSecondary: Time_17_00,
      isPositive: true,
    },
  ];
  const transactionsDetailsTwoActions = [
    {
      txtPrimary: Recipient_str,
      txtSecondary: userNameSD,
    },
    {
      txtPrimary: Amount,
      txtSecondary: two_hundred_dollars,
    },
  ];
  const transactionsDetailsOneAction = [
    {
      txtPrimary: Trx_ID,
      txtSecondary: Trx_ID_number,
    },
    {
      txtPrimary: Trx_date,
      txtSecondary: Trx_date_number,
    },
    {
      txtPrimary: Account_number,
      txtSecondary: Account_number_number,
    },
    {
      txtPrimary: Account_name,
      txtSecondary: userNameSD,
    },
    {
      txtPrimary: CBS_ID,
      txtSecondary: CBS_ID_number,
    },
    {
      txtPrimary: Amount,
      txtSecondary: two_hundred_dollars,
    },
  ];

  return (
    <SimulatorsViewerArrangement>
      <AccountTransactionFP
        globJSON={globJSON}
        language={language}
        simPlatform={simPlatform}
        slideshowRefs={slideshowRefs}
        TopTitle={enable_more_details_per_transaction ? Default_view_indication : Default_view}
        transactionsList={enable_more_details_per_transaction ? transactionsListTime : transactionsListDate}
        subCategory={subCategory}
      />
      <AccountTransactionFP
        globJSON={globJSON}
        language={language}
        simPlatform={simPlatform}
        slideshowRefs={slideshowRefs}
        withTwoPoints
        TopTitle={Multiple_accounts_categories}
        transactionsList={transactionsListTime}
        subCategory={subCategory}
      />
      {enable_more_details_per_transaction
                && (
                <SimulatorsViewerArrangement>
                  <TransactionDetailsFP
                    globJSON={globJSON}
                    simPlatform={simPlatform}
                    subCategoryId={subCategoryId}
                    headlineText={transactions.transaction_details}
                    TopTitle={Transaction_details_two_action}
                    slideshowRefs={slideshowRefs}
                    twoActions
                    transactionsList={transactionsDetailsTwoActions}
                  />
                  <TransactionDetailsFP
                    globJSON={globJSON}
                    simPlatform={simPlatform}
                    subCategoryId={subCategoryId}
                    headlineText={transactions.transaction_details}
                    TopTitle={Transaction_details_one_action}
                    slideshowRefs={slideshowRefs}
                    transactionsList={transactionsDetailsOneAction}
                  />
                  <ConfirmActionFP
                    globJSON={globJSON}
                    simPlatform={simPlatform}
                    subCategoryId={subCategoryId}
                    headlineText={transactions.confirm_action}
                    TopTitle={Confirm_action}
                    slideshowRefs={slideshowRefs}
                  />
                  <ActionSuccessFP
                    globJSON={globJSON}
                    transactions={transactions}
                    language={language}
                    simPlatform={simPlatform}
                    slideshowRefs={slideshowRefs}
                    TopTitle={Action_success}
                    largeText={SMS_sent}
                  />
                </SimulatorsViewerArrangement>
                )}
    </SimulatorsViewerArrangement>
  );
};

export default AccountInfoInOutDF;
